import {
  DateFormatPreset,
  formatDateString,
} from '@work4all/utils/lib/date-utils/formatDateString';

export const formaters = {
  dateSimple2year: (input: string) =>
    formatDateString(input, DateFormatPreset.DATE_SIMPLE_2YEAR),
};
